/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  position: relative;
}

::slotted(eon-ui-bullet-list-item) {
  margin-bottom: 16px !important;
}

::slotted(eon-ui-bullet-list-item[size="large"]) {
  margin-bottom: 24px !important;
}

::slotted(eon-ui-bullet-list-item:last-of-type) {
  margin-bottom: 0 !important;
}

:host([alignable="true"]) {
  .#{$prefix}bullet-list-wrapper {
    display: inline-block;
  }
}

:host([centered="true"]) {
  .#{$prefix}bullet-list-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ::slotted(eon-ui-bullet-list-item) {
    text-align: center;
  }
}
